module.exports = __webpack_public_path__ + "img/08.402750e7.jpg";